import {LazyLoad, RiveFetch} from "parts";
import {Trans, useTranslation} from "react-i18next";
import {LanguageEnum} from "_business";

export function Guarantee() {
  const {t, i18n} = useTranslation('common', {keyPrefix: 'paywall.info'})

  const isRtl = document.documentElement.getAttribute('dir') === 'rtl'

  return (
    <div id={'guarantee'} className={'block'}>
      <div style={{
        width: 80, height: 80, marginBottom: '0.5rem',
        ...(
          isRtl
            ? {float: 'left', marginRight: '1.25rem'}
            : {float: 'right', marginLeft: '1.25rem'}
        )
      }}>
        {
          i18n.resolvedLanguage === 'ar'
            ? <img width={80} height={80} src={'/static/i18/ar/img/paywall/guarantee.png'} loading={'lazy'} alt={'Guarantee'}/>
            :
            <LazyLoad offset={0}>
              <RiveFetch width={80} height={80} locale={['de', 'fr'].includes(i18n.resolvedLanguage)}
                        src={`moneyback.riv`} stateMachines="money_back"
                        inputName={'localisation_id'}
                        value={
                          ['en', 'es'].includes(i18n.resolvedLanguage)
                            ? LanguageEnum[i18n.resolvedLanguage]
                            : LanguageEnum.en
                        }
              />
            </LazyLoad>
        }
      </div>
      <p className={'mb-2'}><strong>{t('moneyBack.title')}</strong></p>
      <p className={'notice sm mb-2'}>{t('moneyBack.p1')}</p>
      <p className={'notice sm'}>
        <Trans i18nKey="moneyBack.p2" t={t}>
          We guarantee you’ll see the results or you’ll receive a full refund within 30 days after your purchase. Find
          out more about the refund policy in our <a rel="noreferrer"
                                                     href={process.env.REACT_APP_WEB_LINK + 'subscription'}
                                                     className={'link nowrap'} target={'_blank'}>Subscription Policy</a>.
        </Trans>
      </p>
    </div>
  )
}